/* eslint-disable no-param-reassign */
/* 轮子动画 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class WheelFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Top,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.Top;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.WHEEL;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof WheelFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        const { width, height, bounds } = canvas;
        const { x, y } = bounds;
        const centerX = x + (width / 2);
        const centerY = y + (height / 2);
        const radius = width + height;
        /**
         * NOTE:
         * 轮子动画中 presetSuType 不再标识方向，标识的是轮幅的划分
         * 例如 PresetSubType.Bottom = 4, 表示 4 轮幅
         */
        const stepRadius = Math.PI * 2 / this.direction;
        const startAngle = -0.5 * Math.PI;
        const destination = this.action === Action.ENTR ? 'destination-in' : 'destination-out';

        canvas.globalCompositeOperation = destination;
        // NOTE: beginPath 置于循环外，将循环内所有子路径视为一个形状，如此在与底层元素叠加时候不会相互干扰
        canvas.beginPath();
        for (let i = 0; i < this.direction; i++) {
            canvas.moveTo(centerX, centerY);
            const start = startAngle + (stepRadius * i);
            const end = start + (this.rate * stepRadius);
            canvas.arc(centerX, centerY, radius, start, end);
        }
        canvas.fill();
        canvas.globalCompositeOperation = 'source-over';
    }
}
